import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { defaultTo } from 'ramda';

import styles from './styles.m.scss';

import { handleError, handleSuccess } from '../../../../../util/forms';
import { apiUpdateRegistration } from '../../../../../api/registration';

import Footer from '../../../../../components/Accordion/Footer';
import EditField from '../../../../../components/Forms/EditField';
import * as yup from 'yup';

const propTypes = {
  registration: PropTypes.object,
  updateRegistration: PropTypes.func,
  setStep: PropTypes.func,
  step: PropTypes.number,
};

const CertificateName = ({ handleBlur, handleChange, handleSubmit, isSubmitting, isValid, step, setStep, values }) => (
  <form>
    <h2 className={styles.stepHeader}>Please type your name exactly as it is to appear on your certificate.</h2>
    <EditField
      name="certificateName"
      label="Certificate Name"
      value={values.certificateName}
      onBlur={handleBlur}
      onChange={handleChange}
    />
    <Footer step={step} setStep={setStep} isValid={isValid} isSubmitting={isSubmitting} handleSubmit={handleSubmit} />
  </form>
);

CertificateName.propTypes = propTypes;

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateRegistration(props.registration.id, { stepName: props.name, ...payload })
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ registration }) => ({
    certificateName: defaultTo('', registration.certificateName),
  }),
  validationSchema: () =>
    yup.object().shape({
      certificateName: yup.string().required(),
    }),
  isInitialValid: ({ initialValues, validationSchema }) => validationSchema().isValidSync(initialValues),
  validateOnChange: true,
})(CertificateName);
